import React, { useState, useEffect, useRef } from "react";
import {Col, Container, Modal, Row, Form, Spinner, Button }from 'react-bootstrap';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import MultiSelectDropdown from "../Controls/multiselectdropdown";
import { useSelector } from "react-redux";
import TreatedTripDialogue from "./TreatedTripDialogue";
import AssignAction from "./AssignAction";
import UnAssignAction from "./UnAssignAction";
import NoShow from "./NoShow";
import NOSHOWREQ from "./NoShowReq";
import PauseUnPause from "./PauseUnPause";
import DueNow from "./DueNow";
import DispatchAction from "./DispatchAction";
import ForceDispatch from "./ForceDispatch";
import APICom from "../../utils/helpers/APICom";
import { HotKeys } from "react-hotkeys";
import {Icon} from '@iconify/react';
import { configure } from "react-hotkeys";
import ModuleSecurity from "../../utils/helpers/ModuleSecurity";
configure({
    ignoreTags: []
});
const TripActions = (props) => {
    
    const chkVehicleRequiredRef = useRef();
    let _CancelAllowed = ModuleSecurity.CheckModuleSecurityByTag("tag_CancelRequest");
    let _ApproveNoShowAllowed = ModuleSecurity.CheckModuleSecurityByTag("tag_ApproveNoShow");
    let _DueNowRequestAllowed = ModuleSecurity.CheckModuleSecurityByTag("tag_DueNowRequest");
    let _DispatchActionsAllowed = ModuleSecurity.CheckModuleSecurityByTag("tag_DispatchActions");
    let _DSPCAllowed = ModuleSecurity.CheckModuleSecurityByTag("DSPC");

    const [State_CancelAllowed, set_State_CancelAllowed] = useState(_CancelAllowed);
    const [State_ApproveNoShowAllowed, set_State_ApproveNoShowAllowed] = useState(_ApproveNoShowAllowed);
    const [State_DueNowRequestAllowed, set_State_DueNowRequestAllowed] = useState(_DueNowRequestAllowed);
    const [State_DispatchActionsAllowed, set_State_DispatchActionsAllowed] = useState(_DispatchActionsAllowed);
    const [State_DSPCAllowed, set_State_DSPCAllowed] = useState(_DSPCAllowed);
    const [ButtonEnabledAccordingToTripState, set_ButtonEnabledAccordingToTripState] = useState({
        btnDueNow: true,
        btnAssign: true,
        btnDispatch: true,
        btnReDispatch: true,
        btnUnAssign: true,
        btnUnAssignAffiliate: true,
        btnTreated: true,
        btnGroupAssign: true,
        btnGroupUnAssign: true,
        btnNoShow: true,
        btnPutOnWall: true,
        btnCopyToSRQ: true,
        btnCanceled: true,
        btnPauseUnPause: true,
        disableDriverVehicleSelect: true,
        pauseUnPauseBtnText: "PAUSE TRIP" // This remains unchanged as it's a string
      });

    const { DispatchVehicleData, DispatchDriverData, AffiliateData, ASCSSettingData }= useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);
    const [showTreatedResaonDialog, setshowTreatedResaonDialog] = useState(false);
    const [vehicleFilterMultiSelect, setVehicleFilterMultiSelect] = useState({options: [], DropdownMode: 'rS', styles:{width:"98%", marginLeft:"0px"}, selectedValues:[], className: 'TripActionsVehicleSelect', rsMenuWidth: "100%"});
    const [driverFilterMultiSelect, setDriverFilterMultiSelect] = useState({options: [], DropdownMode: 'rS', styles:{width:"98%", marginLeft:"0px"}, selectedValues:[], className: 'TripActionsDriverSelect', rsMenuWidth: "100%"});
    const [selectedVehicle, setSelectedVehicle] = useState("-1");
    const [selectedDriver, setSelectedDriver] = useState("-1");
    const [invokeAssignComponent, setInvokeAssignComponent] = useState(false);
    const [invokeDispatchComponent, setinvokeDispatchComponent] = useState(false);
    const [invokeUnAssignComponent, setInvokeUnAssignComponent] = useState(false);
    const [invokeNoShowComponent, setInvokeNoShowComponent] = useState(false);
    const [invokeNoShowReqComponent, setInvokeNoShowReqComponent] = useState(false);
    const [invokePauseUnPauseComponent, setPauseUnPauseComponent] = useState(false);
    const [btnPauseTripText, setBtnPauseTripText] = useState('PAUSE TRIP');
    const [btnDispatchText, setbtnDispatchText] = useState('DISPATCH');
    const [btnPutOnWallText, setbtnPutOnWallText] = useState('PUT ON WALL');
    const [invokeDueNowComponent, setInvokeDueNowComponent] = useState(false);
    const [isDueNowProcessing, setDueNowProcessing] = useState(false);
    const [pauseProcessing, setPauseProcessing] = useState(false);
    const [isUnAssignProcessing, setUnAssignrocessing] = useState(false);
    const [invokePutOnWall, setinvokePutOnWall] = useState(false);
    const [ShowModalDialog, setShowModalDialog] = useState({"Show":false, "Title": "", "Msg":""});
    const [forceDispatchObj, setForceDispatchObj] = useState({invokeForceDispatch: false, isForceDispatchProcessing: false, btnForceDispatchText: "FORCE DISPATCH"});

    const [SmartDevices, setSmartDevices] = useState([]);

    const [pVehicleType, setpVehicleType] = useState("");
    const [pStatus, setpStatus] = useState("");
    const [pStatusColor, setpStatusColor] = useState("");
    const [pDriverName, setpDriverName] = useState("");
    const [pManualDriverVehicleChange, setpManualDriverVehicleChange] = useState(false);
    const [shortcutMenu, setShortcutMenu] = useState(false);
    const [shortcutKeys, setShortcutKeys] = useState([{"action": "Put On Wall", "shortcut":"ALT + W"},{"action": "Due Now", "shortcut":"ALT + D"},{"action": "Pause", "shortcut":"ALT + P"},{"action": "Assign", "shortcut":"ALT + A"},{"action": "Un-Assign", "shortcut":"ALT + U"},
    {"action": "NoShow", "shortcut":"ALT + N"},{"action": "Re-Dispatch", "shortcut":"ALT + R"},{"action": "Treated", "shortcut":"ALT + T"},{"action": "Force Dispatch", "shortcut":"ALT + F"},{"action": "Copy to SRQ", "shortcut":"ALT + C"},
    {"action": "Group/Un-Group Dialog", "shortcut":"CTRL + G"},{"action": "Cluster/Un-Cluster Dialog", "shortcut":"CTRL + Q"},{"action": "Broker Action Dialog", "shortcut":"CTRL + B"},{"action": "Trip Actions Dialog", "shortcut":"CTRL + D"},{"action": "Trip Information Dialog", "shortcut":"CTRL + I"},{"action": "Cancel/Activate Dialog", "shortcut":"CTRL + X"}]);
    const [shortcutListHTML, setShortcutListHTML] = useState([]);
    useEffect(()=> {
        let VehiclesOptionsSelected = [];
        let DriverOptionsSelected = [];
        let ListofItems = shortcutKeys.filter(item=>{
            if(!State_CancelAllowed && item.action === "Cancel/Activate Dialog"){
                return false;
            }
            else if(!State_DueNowRequestAllowed && item.action === "Due Now"){
                return false;
            }
            else if(!State_ApproveNoShowAllowed && item.action === "NoShow"){
                return false;
            }
            else if(!State_DispatchActionsAllowed && item.action === "Re-Dispatch"){
                return false;
            }
            else if(!State_DispatchActionsAllowed && item.action === "Force Dispatch"){
                return false;
            }
            return true;
        }).map(function(item, index){
            return(
              <tr key={index}><td className="border border-light" style={{background:"#efe1d7"}}>{item.action}</td><td className="border border-light" style={{background:"#efe1d7"}}>{item.shortcut}</td></tr>
            );
        });
        setShortcutListHTML(ListofItems);
        if(props.GridRowData !== undefined && props.GridRowData.length > 0){
            let pSelectedVehicleID = -1;
            let pSelectedDriverID = -1;
            if(DispatchVehicleData !== undefined && DispatchVehicleData !== null){
                let VehiclesOptions = [];
                try{
                    let iAssignedVehicleID_temp = Number(props.GridRowData[0].iAssignedVehicleId);
                    let iSpecialVehicleID_temp = Number(props.GridRowData[0].iSpecialVehicleId);
                    if (!isNaN(iAssignedVehicleID_temp) && Number.isInteger(iAssignedVehicleID_temp) && iAssignedVehicleID_temp > 0) {
                        pSelectedVehicleID = iAssignedVehicleID_temp;
                    }
                    else if (!isNaN(iSpecialVehicleID_temp) && Number.isInteger(iSpecialVehicleID_temp) && iSpecialVehicleID_temp > 0) {
                        pSelectedVehicleID = iSpecialVehicleID_temp;
                    }
                }
                catch(e) { }
                
                try{
                    let iAssignedDriverID_temp = Number(props.GridRowData[0].AssignedDriverId);
                    let iSpecialDriverID_temp = Number(props.GridRowData[0].iSpecialDriverId);
                    if (!isNaN(iAssignedDriverID_temp) && Number.isInteger(iAssignedDriverID_temp) && iAssignedDriverID_temp > 0) {
                        pSelectedDriverID = iAssignedDriverID_temp;
                    }
                    else if (!isNaN(iSpecialDriverID_temp) && Number.isInteger(iSpecialDriverID_temp) && iSpecialDriverID_temp > 0) {
                        pSelectedDriverID = iSpecialDriverID_temp;
                    }
                }
                catch(e) { }

                let DispatchVehiclesByAffiliate = DispatchVehicleData[props.GridRowData[0].iSRATSPID];
                if(DispatchVehiclesByAffiliate !== "" && DispatchVehiclesByAffiliate !== undefined && DispatchVehiclesByAffiliate !== null){
                    JSON.parse(DispatchVehiclesByAffiliate).map((item) => {
                        VehiclesOptions.push({"label":item.VehicleNumber, "value":item.VehicleID});
                        if(pSelectedVehicleID > 0 && item.VehicleID === pSelectedVehicleID){
                            VehiclesOptionsSelected.push({"label":item.VehicleNumber, "value":item.VehicleID});
                        }
                    });
                }
                if(VehiclesOptions.length > 0 && VehiclesOptionsSelected.length == 0)
                {
                    setVehicleFilterMultiSelect({...vehicleFilterMultiSelect, ...{options: VehiclesOptions}});
                }
                else if(VehiclesOptions.length > 0 && VehiclesOptionsSelected.length > 0) {
                    setVehicleFilterMultiSelect({...vehicleFilterMultiSelect, ...{options: VehiclesOptions, selectedValues: VehiclesOptionsSelected}});
                }
            }
            if(DispatchDriverData !== "" && DispatchDriverData !== undefined && DispatchDriverData !== null){
                let DriversOptions = [];
                let DispatchDriverByAffiliate = DispatchDriverData[props.GridRowData[0].iSRATSPID];
                if(DispatchDriverByAffiliate !== "" && DispatchDriverByAffiliate !== undefined && DispatchDriverByAffiliate !== null){
                    JSON.parse(DispatchDriverByAffiliate).map((item) => {
                        DriversOptions.push({"label":item.DriverInfo, "value":item.DriverID});
                        if(pSelectedDriverID > 0 && item.DriverID === pSelectedDriverID){
                            DriverOptionsSelected.push({"label":item.DriverInfo, "value":item.DriverID});
                        }
                    });
                }
                if(DriversOptions.length > 0 && DriverOptionsSelected.length == 0)
                {
                    setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{options: DriversOptions}});
                }
                else if(DriversOptions.length > 0 && DriverOptionsSelected.length > 0) 
                {
                    setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{options: DriversOptions, selectedValues: DriverOptionsSelected}});
                }
            }
        }
        else{
            ShowDialogueMsg("No Trip Selected Alert", "Please select a trip to continue...");
            return;
        }
        LoadSmartDevices(VehiclesOptionsSelected.length>0?VehiclesOptionsSelected[0].value:-1, DriverOptionsSelected.length>0?DriverOptionsSelected[0].value:-1);
        if(props.triggerUnAssign){handleUnAssignClick(); props.setTriggerUnAssign(false);}
    }, [props.triggerUnAssign]);
    
    useEffect(() => {
        if (props.GridRowData.length > 0) {
            UpdateSmartDevicesData(VehicleSelectFunction);
        }
    }, [selectedVehicle]); // Triggered when the vehicle is selected
    
    useEffect(() => {
        if (props.GridRowData.length > 0) {
            UpdateSmartDevicesData(DriverSelectFunction);
        }
    }, [selectedDriver]); // Triggered when the driver is selected

    const SetButtonEnabledAccordingToTripState = () => {
        let _TripRequestStatus = "NONE";
        let _ServiceStatus = "1";
        let _TripState = "";
        let _TableSource = "";
        let _routedTrip = "";
        let btn_DueNow = true, 
            btn_Assign = true, 
            btn_Dispatch = true, 
            btn_ReDispatch = true, 
            btn_UnAssign = true, 
            btn_UnAssignAffiliate = true, 
            btn_Treated = true, 
            btn_GroupAssign = true, 
            btn_GroupUnAssign = true,
            btn_NoShow = true, 
            btn_PutOnWall = true, 
            btn_CopyToSRQ = true, 
            btn_Canceled = true, 
            btn_PauseUnPause = true, 
            DisableDriverVehicleSelect = true, 
            PauseUnPauseBtnText = "PAUSE TRIP";

        try{
            if(props.GridRowData.length > 0){
                _TripRequestStatus = props.GridRowData[0].TripRequestStatus.toLowerCase();
                _TripState = props.GridRowData[0].TripState;
                _TableSource = props.GridRowData[0].TableSource.toLowerCase();
                _ServiceStatus = props.GridRowData[0].ServiceStatus.toLowerCase();
                _routedTrip = props.GridRowData[0].Route;
            }
            else{
                return {
                    btnDueNow: btn_DueNow,
                    btnAssign: btn_Assign,
                    btnDispatch: btn_Dispatch,
                    btnReDispatch: btn_ReDispatch,
                    btnUnAssign: btn_UnAssign,
                    btnUnAssignAffiliate: btn_UnAssignAffiliate,
                    btnTreated: btn_Treated,
                    btnGroupAssign: btn_GroupAssign,
                    btnGroupUnAssign: btn_GroupUnAssign,
                    btnNoShow: btn_NoShow,
                    btnPutOnWall: btn_PutOnWall,
                    btnCopyToSRQ: btn_CopyToSRQ,
                    btnCanceled: btn_Canceled,
                    btnPauseUnPause: btn_PauseUnPause,
                    disableDriverVehicleSelect: DisableDriverVehicleSelect,
                    pauseUnPauseBtnText: PauseUnPauseBtnText
                  };
            }
        }
        catch(e) { }
        try{
            btn_DueNow = false;
            btn_Assign = false;
            btn_Dispatch = false;
            btn_ReDispatch = false;
            btn_UnAssign = false;
            btn_UnAssignAffiliate = false;
            btn_Treated = false;
            btn_GroupAssign = false;
            btn_GroupUnAssign = false;
            btn_NoShow = false;
            btn_PutOnWall = false;
            btn_CopyToSRQ = true; // In old web mrms it is set to true for all cases
            btn_Canceled = false;
            btn_PauseUnPause = false;
            DisableDriverVehicleSelect = false;

            if (_TripRequestStatus == "none" || _TripRequestStatus == "late" || _TripRequestStatus == "") {
                btn_DueNow = true; btn_Assign = true; btn_Dispatch = true; btn_UnAssignAffiliate = true; btn_GroupAssign = true; btn_GroupUnAssign = true; /* ETS =	14158  */ btn_PutOnWall = true; btn_Canceled = true;
                btn_PauseUnPause = true;
            }
            else if (_TripRequestStatus == "assigned" || _TripRequestStatus == "bidoffered" || _TripRequestStatus == "bid" || _TripRequestStatus == "tripoffered" || _TripRequestStatus == "rejected") {
                btn_DueNow = true; btn_Dispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_Treated = true; btn_GroupAssign = true; btn_Canceled = true; btn_PauseUnPause = true;
                if (_routedTrip != "") {
                    btn_Assign = true;
                }
            }
            else if (_TripRequestStatus == "dispatched") {
                btn_DueNow = true; btn_Assign = false; btn_ReDispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_Treated = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_Canceled = true;
            }
            else if (_TripRequestStatus == "accepted") {
                btn_DueNow = true; btn_ReDispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_Canceled = true; btn_NoShow = true;
            }
            else if (_TripRequestStatus == "irtpu") {
                btn_ReDispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_Canceled = true; btn_NoShow = true;
            }
            else if (_TripRequestStatus == "atlocation" || _TripRequestStatus == "callout") {
                btn_ReDispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_PutOnWall = false; btn_CopyToSRQ = false; btn_Canceled = true;
                btn_NoShow = true;
            }
            else if (_TripRequestStatus == "noshowreq" || _TripRequestStatus == "noshow") {
                btn_ReDispatch = true; btn_UnAssign = true; btn_UnAssignAffiliate = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_PutOnWall = false; btn_CopyToSRQ = true; btn_Canceled = true;
                btn_NoShow = _TripRequestStatus == "noshowreq" ? true : false;
            }
            else if (_TripRequestStatus == "cancelled" || _ServiceStatus.indexOf("cancel") > -1) {
                btn_Treated = true; btn_CopyToSRQ = true;// btn_GroupAssign = true;
            }
            else if (_TripRequestStatus == "pickedup") {
                btn_Treated = true; btn_GroupAssign = true; btn_GroupUnAssign = true; btn_Canceled = true; btn_NoShow = true; btn_ReDispatch = true; btn_UnAssign = true;
            }
            else if (_TripRequestStatus.indexOf("treat") > -1 || _ServiceStatus.indexOf("treat") > -1 || _TripRequestStatus.indexOf("drop") > -1 || _ServiceStatus.indexOf("drop") > -1) {
                btn_CopyToSRQ = false;
            }
            if (_DSPCAllowed == false) {
                btn_Assign = false; btn_Dispatch = false; btn_UnAssign = false; /*btn_Treated = false;*/ btn_GroupAssign = false; btn_GroupUnAssign = false; btn_UnAssignAffiliate = false; btn_ReDispatch = false;
                btn_NoShow = false; btn_PauseUnPause = false;
            }
            if (_DispatchActionsAllowed == false) {
                btn_Assign = false; btn_Dispatch = false; btn_UnAssign = false; /*btn_Treated = true;*/ btn_GroupAssign = false; btn_GroupUnAssign = false; btn_UnAssignAffiliate = false; btn_ReDispatch = true;
                btn_PauseUnPause = false; btn_PutOnWall = false; btn_CopyToSRQ = false; DisableDriverVehicleSelect = true;//14097-GA Dispatch Actions
            }
            //================== (Start) Added Code For Apply Rights of DueNow,NoShow And Cancel Actions For NewRequestHTML Page =================//
            if (_CancelAllowed == false) {
                btn_Canceled = false;
            }
            if (_ApproveNoShowAllowed == false) {
                btn_NoShow = false;
            }
            if (_DueNowRequestAllowed == false) {
                btn_DueNow = false;
            }
        }
        catch(e) {console.log(e); }
        try{
            if(_TripState.toLowerCase() === "paused"){
                PauseUnPauseBtnText = "RESUME TRIP";
            }
        }
        catch(e) { }
        console.log({
            btnDueNow: btn_DueNow,
            btnAssign: btn_Assign,
            btnDispatch: btn_Dispatch,
            btnReDispatch: btn_ReDispatch,
            btnUnAssign: btn_UnAssign,
            btnUnAssignAffiliate: btn_UnAssignAffiliate,
            btnTreated: btn_Treated,
            btnGroupAssign: btn_GroupAssign,
            btnGroupUnAssign: btn_GroupUnAssign,
            btnNoShow: btn_NoShow,
            btnPutOnWall: btn_PutOnWall,
            btnCopyToSRQ: btn_CopyToSRQ,
            btnCanceled: btn_Canceled,
            btnPauseUnPause: btn_PauseUnPause,
            disableDriverVehicleSelect: DisableDriverVehicleSelect,
            pauseUnPauseBtnText: PauseUnPauseBtnText
          });
        return {
            btnDueNow: btn_DueNow,
            btnAssign: btn_Assign,
            btnDispatch: btn_Dispatch,
            btnReDispatch: btn_ReDispatch,
            btnUnAssign: btn_UnAssign,
            btnUnAssignAffiliate: btn_UnAssignAffiliate,
            btnTreated: btn_Treated,
            btnGroupAssign: btn_GroupAssign,
            btnGroupUnAssign: btn_GroupUnAssign,
            btnNoShow: btn_NoShow,
            btnPutOnWall: btn_PutOnWall,
            btnCopyToSRQ: btn_CopyToSRQ,
            btnCanceled: btn_Canceled,
            btnPauseUnPause: btn_PauseUnPause,
            disableDriverVehicleSelect: DisableDriverVehicleSelect,
            pauseUnPauseBtnText: PauseUnPauseBtnText
          };
    }
    
    const LoadSmartDevices = async (VehicleIDD, DriverIDD) => {
        let requestObj = {
            "VehicleID":-1
        }
        let response = await APICom.fetchData("", "TripActions/GetSmartDeviceList", "post", { "Content-Type": "application/json" }, requestObj, null);
        if(response.error === ""){
            let data = response.data;
            setSmartDevices(data);
            if(VehicleIDD > 0){
                setSelectedVehicle(VehicleIDD.toString());
            }
            if(DriverIDD > 0){
                setSelectedDriver(DriverIDD.toString());
            }
        }
    }


    const UpdateSmartDevicesData = async (callback) => {
        let requestObj = {
            "VehicleID": -1
        };
        let response = await APICom.fetchData("", "TripActions/GetSmartDeviceList", "post", { "Content-Type": "application/json" }, requestObj,null);
        if (response.error === "") {
            let data = response.data;
            setSmartDevices(data);
            if (callback) {
                callback(); // Call the relevant function after setting smart devices
            }
        }
    };


    const GetVehicleTypeByVehicleID = (VehicleID) => {
        let pvehicleType = "";
        let DispatchVehiclesByAffiliate = DispatchVehicleData[props.GridRowData[0].iSRATSPID];
        if(DispatchVehiclesByAffiliate !== "" && DispatchVehiclesByAffiliate !== undefined && DispatchVehiclesByAffiliate !== null){
            JSON.parse(DispatchVehiclesByAffiliate).map((item) => {
                if(item.VehicleID === VehicleID){
                    pvehicleType = item.VehicleType;
                }
            });
        }
        return pvehicleType;
    }
    
    const GetDriverSelectObjectByDriverID = (driverid) => {
        let DriversOptions = [];
        let DispatchDriverByAffiliate = DispatchDriverData[props.GridRowData[0].iSRATSPID];
        if(DispatchDriverByAffiliate !== ""){
            JSON.parse(DispatchDriverByAffiliate).map((item) => {
                if(item.DriverID.toString() === driverid.toString()) {
                    DriversOptions.push({"label":item.DriverInfo, "value":item.DriverID});
                }
            });
        }
        return DriversOptions;
    }
    const GetDriverNameByDriverID = (driverid) => {
        let DriversName = "";
        let DispatchDriverByAffiliate = DispatchDriverData[props.GridRowData[0].iSRATSPID];
        if(DispatchDriverByAffiliate !== ""){
            JSON.parse(DispatchDriverByAffiliate).map((item) => {
                if(item.DriverID.toString() === driverid.toString()) {
                    DriversName = item.DriverName;
                }
            });
        }
        return DriversName;
    }
    const GetVehicleSelectObjectByVehicleID = (VehicleID) => {
        let VehiclesOptions = [];
        let DispatchVehiclesByAffiliate = DispatchVehicleData[props.GridRowData[0].iSRATSPID];
        if(DispatchVehiclesByAffiliate !== ""){
            JSON.parse(DispatchVehiclesByAffiliate).map((item) => {
                if(item.VehicleID.toString() === VehicleID.toString()) {
                    VehiclesOptions.push({"label":item.VehicleNumber, "value":item.VehicleID});
                }
            });
        }
        return VehiclesOptions;
    }
    
    const VehicleSelectCallback = (_selectedVehicleID) => {
        setSelectedVehicle(_selectedVehicleID.toString());
        setpManualDriverVehicleChange(true);
        if(_selectedVehicleID > 0) {
            setVehicleFilterMultiSelect({...vehicleFilterMultiSelect, ...{selectedValues: GetVehicleSelectObjectByVehicleID(_selectedVehicleID)}});
        }
        document.getElementsByClassName("modal-content")[0].click();
        // document.activeElement.blur();

    }
    const VehicleSelectFunction = () => {
        let _selectedVehicleID = parseInt(selectedVehicle);
        let dispatchMethodVal = 2;
        let _VehType = GetVehicleTypeByVehicleID(_selectedVehicleID);
        let _iSpecialVehicleId = props.GridRowData[0]["iSpecialVehicleId"];
        let _isRequiredVehicle = props.GridRowData[0]["IsVehicleRequired"];
        if (parseInt(_iSpecialVehicleId) > 0 && _selectedVehicleID == _iSpecialVehicleId && String(_isRequiredVehicle).toLowerCase() == "true") {
            chkVehicleRequiredRef.current.checked = true;
        }
        else{
            chkVehicleRequiredRef.current.checked = false;
        }
        try{
            dispatchMethodVal = parseInt(JSON.parse(ASCSSettingData[parseInt(props.GridRowData[0].iSRATSPID)]).filter(function(item) { return item["SubTitle"] === "DispatchMethod"; })[0].value)
        }
        catch(e){}
        try{
            dispatchMethodVal = dispatchMethodVal.toString();
        }
        catch(e){dispatchMethodVal = "2";}
        try{
            
            let p_selectedDriverID = -1;
            if(parseInt(dispatchMethodVal) == 0 || parseInt(dispatchMethodVal) == 2){
                if(parseInt(_selectedVehicleID) > 0) {
                    let mSDobject = null;
                    let pcolor = "#FF0000";
                    let p_vType = "";
                    let p_Name = "";
                    let p_State = "";
                    SmartDevices.every(function(sd) {
                        if(sd.IVEHICLEID.toString() === _selectedVehicleID.toString() && sd.STATE !== "DISCONNECTED") {
                            mSDobject = sd;
                            return false;
                        }
                        return true;
                    });
                    if(mSDobject === null) {
                        SmartDevices.every(function(sd) {
                            if(sd.IVEHICLEID.toString() === _selectedVehicleID.toString()) {
                                mSDobject = sd;
                                return false;
                            }
                            return true;
                        });
                    }
                    if(mSDobject != null) {
                        p_State = mSDobject["STATE"];
                        if(mSDobject.bOnBreak.toString().toUpperCase() == "TRUE") {
                            p_State = "OnBreak";
                            pcolor = "#FF0000";
                        }
                        else if(mSDobject.bUnAvailable.toString().toUpperCase() == "TRUE") {
                            p_State = "UnAvailable";
                            pcolor = "#FF0000";

                        }
                        else{
                            pcolor = "#000000";

                        }
                        p_vType = mSDobject["VEH TYPE"];
                        p_Name = mSDobject["DRIVER NAME"];
                        p_selectedDriverID = mSDobject.IDRIVERID;
                    }
                    setpVehicleType(p_vType);
                    setpStatus(p_State);
                    setpStatusColor(pcolor);
                    if(pManualDriverVehicleChange == true) {
                        setpDriverName(p_Name);
                    }
                }
                if(driverFilterMultiSelect.options.length > 0 && pManualDriverVehicleChange == true){
                    if(p_selectedDriverID > 0) {
                        setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{selectedValues: GetDriverSelectObjectByDriverID(p_selectedDriverID)}});
                        setSelectedDriver(p_selectedDriverID.toString());
                    }
                    else{
                        setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{selectedValues: []}});
                        setSelectedDriver("-1");
                        setpVehicleType("");
                        setpStatus("");
                        setpDriverName("");
                    }
                }
            }
        }
        catch(e){}
    }
    const DriverSelectCallback = (_selectedDriverID) => {
        setSelectedDriver(_selectedDriverID.toString());
        setpManualDriverVehicleChange(true);
        if(_selectedDriverID > 0) {
            setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{selectedValues: GetDriverSelectObjectByDriverID(_selectedDriverID)}});
        }
    }
    const handleInvokeShortcutModalToggle = () =>{
        setShortcutMenu(prevCheck => !prevCheck);
    }
    const DriverSelectFunction = () => {
        let _selectedDriverID = selectedDriver;
        let dispatchMethodVal = 2;
        try{
            dispatchMethodVal = parseInt(JSON.parse(ASCSSettingData[parseInt(props.GridRowData[0].iSRATSPID)]).filter(function(item) { return item["SubTitle"] === "DispatchMethod"; })[0].value)
        }
        catch(e){}
        try{
            dispatchMethodVal = dispatchMethodVal.toString();
        }
        catch(e){dispatchMethodVal = "2";}
        try{
            setpDriverName(GetDriverNameByDriverID(_selectedDriverID));
        }
        catch(e){ }
        try{
            let p_selectedVehicleID = -1;
            if(parseInt(dispatchMethodVal) == 1 || parseInt(dispatchMethodVal) == 2){
                if(parseInt(_selectedDriverID) > 0) {
                    let mSDobject = null;
                    let pcolor = "#FF0000";
                    let p_vType = "";
                    let p_Name = "";
                    let p_State = "";
                    SmartDevices.every(function(sd) {
                        if(sd.IDRIVERID.toString() == _selectedDriverID.toString()) {
                            mSDobject = sd;
                            return false;
                        }
                        return true;
                    });
                    if(mSDobject != null) {
                        p_State = mSDobject["STATE"];
                        if(mSDobject.bOnBreak.toString().toUpperCase() == "TRUE") {
                            p_State = "OnBreak";
                            pcolor = "#FF0000";
                        }
                        else if(mSDobject.bUnAvailable.toString().toUpperCase() == "TRUE") {
                            p_State = "UnAvailable";
                            pcolor = "#FF0000";

                        }
                        else{
                            pcolor = "#000000";

                        }
                        p_vType = mSDobject["VEH TYPE"];
                        p_Name = mSDobject["DRIVER NAME"];
                        p_selectedVehicleID = mSDobject.IVEHICLEID;
                    }

                    else{
                        p_State = "Disconnected";
                    }
                    setpVehicleType(p_vType);
                    setpStatus(p_State);
                    setpDriverName(p_Name);
                    setpStatusColor(pcolor);
                }
                if(vehicleFilterMultiSelect.options.length > 0  && pManualDriverVehicleChange == true){
                    if(p_selectedVehicleID > 0) {
                        setVehicleFilterMultiSelect({...vehicleFilterMultiSelect, ...{selectedValues: GetVehicleSelectObjectByVehicleID(p_selectedVehicleID)}});
                        setSelectedVehicle(p_selectedVehicleID.toString());
                    }
                    else{
                        setVehicleFilterMultiSelect({...driverFilterMultiSelect, ...{selectedValues: []}});
                        setSelectedVehicle("-1");
                        setpVehicleType("");
                        setpStatus("Disconnected");
                        setpDriverName("");
                    }
                }
            }
        }
        catch(e){}
    }

    const handleTripActionDialogOpen = () => {
        if(props.GridRowData.length > 0)
        {
            var TripState = props.GridRowData[0].TripState;
            if (TripState != null && TripState != "" && TripState != undefined && TripState.toUpperCase() == "PAUSED") {
                setBtnPauseTripText("RESUME TRIP");
            }
            else {
                setBtnPauseTripText("PAUSE TRIP");
            }
        }
        set_ButtonEnabledAccordingToTripState(SetButtonEnabledAccordingToTripState());
    }

    const keyMap = {
        ALT_W: 'alt+w',
        ALT_D: 'alt+d',
        ALT_P: 'alt+p',
        ALT_A: 'alt+a',
        ALT_C: 'alt+c',
        ALT_U: 'alt+u',
        ALT_T: 'alt+t',
        ALT_F: 'alt+f',
        ALT_N: 'alt+n',
        CLOSE_MODAL: 'esc',
    }

    const handleHotKeys = {
        ALT_W: () => {
            // console.log("ALT_W");
            // e.preventDefault();
            if(ButtonEnabledAccordingToTripState.btnPutOnWall) {
                handlePutOnWallActionClick();
            }
        },
        ALT_D: (event) => {
            // console.log("ALT_D");
            event.preventDefault();
            if(ButtonEnabledAccordingToTripState.btnDueNow) {
                handleDuenowClick();
            }
        },
        ALT_C: () => { //Copy ride function key
            // console.log("ALT_C");
            
        },
        ALT_P: () => {
            // console.log("ALT_P");
            if(ButtonEnabledAccordingToTripState.btnPauseUnPause) {
                handlePausetripClick();
            }
        },
        ALT_A: () => {
            // console.log("ALT_A");
            if(ButtonEnabledAccordingToTripState.btnAssign) {
                handleAssignClick();
            }
        },
        ALT_U: () => {
            // console.log("ALT_U");
            if(ButtonEnabledAccordingToTripState.btnUnAssign) {
                handleUnAssignClick();
            }
        },
        ALT_T: (event) => {
            // console.log("ALT_T");
            event.preventDefault();
            if(ButtonEnabledAccordingToTripState.btnTreated) {
                BtnTreatedClick();
            }
        },
        ALT_F: (event) => {
            // console.log("ALT_F");
            event.preventDefault();
            if(ButtonEnabledAccordingToTripState.btnReDispatch) {
                handleForceDispatchClick();
            }
        },
        ALT_N: () => {
            // console.log("ALT_N");
            if(ButtonEnabledAccordingToTripState.btnNoShow) {
                handleNoShowClick();
            }
        },
        CLOSE_MODAL:() => {
            handleCloseTripActionsDialog()
        },
        
    };

    const handleAssignClick = () => {
        setInvokeAssignComponent(true);
    }

    const handleUnAssignClick = () => {
        setUnAssignrocessing(true);
        setInvokeUnAssignComponent(true);
    }

    const handleNoShowClick = () => {
        if(props.GridRowData.length > 1){
                ShowDialogueMsg("Multiple trips selected", "Please select a trip to perform noshow.");
                return;
        }
        else
        {
            if(props.GridRowData[0]["TripRequestStatus"] == "NOSHOWREQ")
            {
                setInvokeNoShowReqComponent(true);
            }
            else
            {
                setInvokeNoShowComponent(true);
            }
        }
    }

    const handlePausetripClick = () => {
        setPauseUnPauseComponent(true);
        setPauseProcessing(true);
    }

    const handleDuenowClick = () => {
        setDueNowProcessing(true);
        setInvokeDueNowComponent(true);
    }
    const handleDispatchActionClick = () => {
        setinvokeDispatchComponent(true);
    }

    const handleForceDispatchClick = () => {
        setForceDispatchObj((preState) => ({...preState, invokeForceDispatch:true, isForceDispatchProcessing:true}));
    }

    const handleCloseTripActionsDialog = () => {
        UnMountTripActionsComponent();
    }

    const UnMountTripActionsComponent = () => {
        if(props.showTripActionsDialog)
        {
            props.setShowTripActionsDialog(false);
        }
    }
    const UnMountDispatchActionComponent = () => {
            setinvokeDispatchComponent(false);
            RefreshGridData();
    }
    const RefreshGridData = () => {
        if(typeof props.ReloadDataFunction === 'function'){
            props.ReloadDataFunction();
        }
    }
    const handlePutOnWallActionClick = () => {
        setinvokePutOnWall(true);
        PutOnWallAction();
    }

    // const handleRequiredVehicleChange = (e) => {
    //     console.log(e.target.checked);
    //     console.log(chkVehicleRequiredRef.current.checked);
    // }

    const CheckIfTripIsBrokerTrip = async (iSRATSPID) => {
        let bQualifyAsBrokerTrip = false;
        try {
            for (var i = 0; i < AffiliateData.length; i++) {
                if (AffiliateData[i].AffiliateID.toString() == iSRATSPID.toString()
                    && AffiliateData[i].bBroker.toString().toLowerCase() == "true"
                    //&& AffiliateData[i].EnableAutoAssignBrokerTrips.toLowerCase() == "true"
                    //&& AffiliateData[i].IsExternalDispatch.toString().toLowerCase() == "false"
                ) {
                    bQualifyAsBrokerTrip = true;
                    break;
                }
            }
        }
        catch (dsf) { return false; }
        return bQualifyAsBrokerTrip;
    }
    const PutOnWallAction = async () => {
        try{
            if(props.GridRowData === null || props.GridRowData.length <= 0)
            {
                ShowDialogueMsg("No trip selected", "Please select a trip to put on the wall.");
                return;
            }
            let Queue = "";
            let serviceStatus = props.GridRowData[0]["ServiceStatus"];
            let triprequestStatus = props.GridRowData[0]["TripRequestStatus"];
            let tableSource = props.GridRowData[0]["TableSource"];
            let iSRATSPID = props.GridRowData[0]["iSRATSPID"];
            let CreatedBy = props.GridRowData[0]["CreatedBy"];
            let seridd = props.GridRowData[0]["ServiceID"];
            let ManifestNumber = props.GridRowData[0]["vManifestNumber"];
            let WallRoute = props.GridRowData[0]["bWallRoute"];


            let HasAffiliateInThirdParty = CheckIfTripIsBrokerTrip(iSRATSPID);
            if (CreatedBy != "(ExternalDispatch)" && HasAffiliateInThirdParty == true) {
                setinvokePutOnWall(false);
                ShowDialogueMsg("Wall Restriction", "Put to wall is not allowed for External Trip!");
                return;
            }
            else {
                if (ManifestNumber != "" && WallRoute.toString().toUpperCase() == "TRUE") {
                    let requestObj = {
                        "ManifestNumber":ManifestNumber
                    }
                    let response = await APICom.fetchData("", "TripActions/RemoveManifestToWall", "post", { "Content-Type": "application/json" }, requestObj, null);
                    let data = response.data;
                    if (data[0].Action == "True") {
                        setinvokePutOnWall(false);
                        RefreshGridData();
                        //ShowDialogueMsg("Put On Wall", "Record updated successfully.");
                        //13910-Wall Trip New Dispatch- ReAssgined Notes to close Dialog
                        UnMountTripActionsComponent();
                    }
                    else {
                        setinvokePutOnWall(false);
                        ShowDialogueMsg("Record Not Found", "Unable To Update Record!");
                        return false;
                    }
                }
                else if (ManifestNumber != ""){
                    let requestObj = {
                        "ManifestNumber":ManifestNumber
                    }
                    let response = await APICom.fetchData("", "TripActions/MoveManifestToWall", "post", { "Content-Type": "application/json" }, requestObj, null);
                    let data = response.data;
                    if (data[0].Action == "True") {
                        setinvokePutOnWall(false);
                        RefreshGridData();
                        //ShowDialogueMsg("Put On Wall", "Record updated successfully.");
                        //13910-Wall Trip New Dispatch- ReAssgined Notes to close Dialog
                        UnMountTripActionsComponent();
                    }
                    else {
                        setinvokePutOnWall(false);
                        ShowDialogueMsg("Record Not Found", "Unable To Update Record!");
                        return false;
                    }
                }
                else{
                    if(tableSource === "FromOnDemandTable"){
                        let requestObj = {
                            "ServiceID":seridd,
                            "iModifiedByUID": loginData.iUserID
                        }
                        let response = await APICom.fetchData("", "TripActions/UpdateWallRequestAsNoWall", "post", { "Content-Type": "application/json" }, requestObj, null);
                        let data = response.data;
                        setinvokePutOnWall(false);
                        if (data[0].Action == "True") {
                            RefreshGridData();
                            UnMountTripActionsComponent();
                        }
                        else {
                            ShowDialogueMsg("Record Not Found", "Unable To Update Record!");
                            return false;
                        }
                    }
                    else{
                        let requestObj = {
                            "ServiceID":seridd
                        }
                        let response = await APICom.fetchData("", "TripActions/MarkUnMarkRouteAsWallSchedule", "post", { "Content-Type": "application/json" }, requestObj, null);
                        let data = response.data;
                        setinvokePutOnWall(false);
                        if (data[0].Action == "True") {
                            RefreshGridData();
                            //ShowDialogueMsg("Put On Wall", "Record updated successfully.");
                            //13910-Wall Trip New Dispatch- ReAssgined Notes to close Dialog
                            UnMountTripActionsComponent();
                        }
                        else {
                            ShowDialogueMsg("Record Not Found", "Unable To Update Record!");
                            return false;
                        }
                    }
                }
            }
        }
        catch(e){

        }
    }
    const BtnTreatedClick = (e) => {
        
        //alert("Treated Click" + props.GridRowData["TripRequestStatus"] + props.GridRowData["ServiceStatus"] + props.GridRowData["TableSource"] + props.GridRowData["CreatedBy"] + props.GridRowData["iSRATSPID"] + props.GridRowData["TripRequestStatus"]);
        try{
            var Queue = "";
            var serviceStatus = props.GridRowData[0]["ServiceStatus"];
            var triprequestStatus = props.GridRowData[0]["TripRequestStatus"];
            var tableSource = props.GridRowData[0]["TableSource"];
            if (triprequestStatus.toLowerCase().includes("cancel")) {
                Queue = "Cancelled";
            }
            else if (triprequestStatus.toLowerCase() === "noshow") {
                Queue = "Cancelled";
            }
            else if (serviceStatus.toLowerCase() === "dispatched") {
                Queue = "InProgress";
            }
            else {
                if (tableSource === "FromOnDemandTable")
                    Queue = "OnDemand";
                else
                    Queue = "Scheduled";
            }
            var CreatedBy = props.GridRowData[0]["CreatedBy"];
            var iATSPID = props.GridRowData[0]["iSRATSPID"];
            var HasAffiliateInThirdParty = false;
            //HasAffiliateInThirdParty = CheckIfTripIsBrokerTrip(iATSPID);
            var HasAffiliateInThirdParty = false

            var CreatedBy = props.GridRowData[0]["CreatedBy"];
            if (CreatedBy == "(ExternalDispatch)" && Queue == "Cancelled") {
                alert("This is a broker trip, Treated is not allowed!");
                return false;
            }

            if (CreatedBy !== "(ExternalDispatch)" && HasAffiliateInThirdParty === true) {
                alert("Treated is not allowed for External Trip!");
                return false;
            }
            setshowTreatedResaonDialog(true);
        }
        catch(e){
        }
    }
    const ShowDialogueMsg = (Title, Msg) => {
        setShowModalDialog({"Show":true, "Title": Title, "Msg": Msg});
    }
    const HideDialogueMsg = () => {
        setShowModalDialog({"Show":false, "Title": "", "Msg": ""});
        if(ShowModalDialog.Title === "No Trip Selected Alert")
        {
            handleCloseTripActionsDialog();
        }
    }

    return(
        <>
        <HotKeys keyMap={keyMap} handlers={handleHotKeys}>
        {props.GridRowData.length > 0 ?
            <Modal show={props.showTripActionsDialog} centered size="lg" 
            aria-labelledby="contained-modal-title-vcenter" animation={true} onShow={handleTripActionDialogOpen} onHide={handleCloseTripActionsDialog} backdrop="static" >
                <Modal.Header className='dispatch_action_dialog_header_bgcolor' closeButton>
                    <Modal.Title className='dispatch_action_dialog_title_color user-select-none' id="contained-modal-title-vcenter">
                        Trip Actions
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body className="grid-example">
                        <Container>
                        <Row className="w-100 m-0">
                            <Col xs={2} className="user-select-none p-0">Trip Number:</Col> 
                            <Col className="user-select-none p-0" xs={7}><b style={{float:"left"}}>{props.GridRowData.length === 0 ? "" : props.GridRowData[0]["ConfirmationNo"]} </b></Col>
                            <Col className="justify-content-end d-flex" xs={3}>
                                <Button type='button' variant='light' className='border-0 p-1 rounded' onClick={handleInvokeShortcutModalToggle} title="Show Shortcuts Info">
                                    <Icon icon="bx:info-circle"  className='w-100'  style={{color:"blue", height:"25px", cursor:"pointer"}}/>
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={6} md={3} className="py-1">
                                <Button onClick={handleAssignClick} className="tripaction_btn_color tripaction_btn_width" disabled={!ButtonEnabledAccordingToTripState.btnAssign} value="ASSIGN">ASSIGN</Button>
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                <Button onClick={handleUnAssignClick} className="tripaction_btn_color tripaction_btn_width" value="UN ASSIGN" disabled={!ButtonEnabledAccordingToTripState.btnUnAssign}>
                                {isUnAssignProcessing ? (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                 ) : (
                                    'UN ASSIGN'
                                    )
                                }</Button>
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                {State_DueNowRequestAllowed ? (
                                    <Button onClick={handleDuenowClick} className="tripaction_btn_color tripaction_btn_width" value="DUE NOW" disabled={!ButtonEnabledAccordingToTripState.btnDueNow}>
                                    {isDueNowProcessing ? (
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                    ) : (
                                        'DUE NOW'
                                        )
                                    }
                                    </Button>) : null}
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                {State_ApproveNoShowAllowed ? (<Button onClick={handleNoShowClick} className="tripaction_btn_color tripaction_btn_width" value="NO SHOW" disabled={!ButtonEnabledAccordingToTripState.btnNoShow}>NO SHOW</Button>) : null}
                            </Col>
                        </Row>
                        {/* <Row className="tripaction_btn_seperator"></Row> */}
                        <Row className="mt-1">
                            <Col xs={6} md={3} className="py-1">
                                <Button className="tripaction_btn_color tripaction_btn_width"  value="TREATED" onClick={BtnTreatedClick} disabled={!ButtonEnabledAccordingToTripState.btnTreated}>TREATED</Button>
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                <Button className="tripaction_btn_color tripaction_btn_width" value="PUT ON WALL" onClick={handlePutOnWallActionClick} disabled={!ButtonEnabledAccordingToTripState.btnPutOnWall}>
                                {invokePutOnWall ? (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />) : (btnPutOnWallText)}
                                </Button>
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                <Button onClick={handlePausetripClick} className="tripaction_btn_color tripaction_btn_width" value={btnPauseTripText} >
                                {pauseProcessing ? (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
                                 ) : (
                                    btnPauseTripText
                                    )
                                }</Button>
                            </Col>
                            <Col xs={6} md={3} className="py-1">
                                <Button className="tripaction_btn_color tripaction_btn_width" value="COPY RIDE" disabled={!ButtonEnabledAccordingToTripState.btnCopyToSRQ}>COPY RIDE</Button>
                            </Col>
                        </Row>
                        <Row className="user-select-none mt-1">
                          <b>DISPATCH ACTIONS</b>
                        </Row>
                        <Row className="mt-1">
                            <Col xs={6} md={3}>
                               {State_DispatchActionsAllowed ? ( <Button className="tripaction_btn_color tripaction_btn_width" value="DISPATCH" onClick={handleDispatchActionClick} >
                                    {btnDispatchText}
                                </Button>): null}
                            </Col>
                            <Col xs={6} md={3}>
                                {State_DispatchActionsAllowed ? (
                                <Button className="tripaction_btn_color tripaction_btn_width" value="FORCE DISPATCH" onClick={handleForceDispatchClick}>
                                    {forceDispatchObj.btnForceDispatchText}
                                </Button>) : null}
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row className="user-select-none">
                            <Col xs={6} md={6}>
                                Select Vehicle
                            </Col>
                            <Col xs={6} md={6}>
                                Select Driver
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6} md={6}>
                            <MultiSelectDropdown options={vehicleFilterMultiSelect} showCheckbox={false} SelectionChangeCallback={VehicleSelectCallback} ></MultiSelectDropdown>
                            </Col>
                            <Col xs={6} md={6}>
                            <MultiSelectDropdown options={driverFilterMultiSelect} SelectionChangeCallback={DriverSelectCallback}></MultiSelectDropdown>
                            </Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row className="user-select-none">
                            <Col xs={6} md={3}>
                                <b>Type: </b> {pVehicleType}
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                            <Col xs={6} md={4}>
                                <b style={{color:pStatusColor}}>Status: </b>{pStatus}
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row className="user-select-none">
                            <Col xs={6} md={4}>
                                <b>Name: </b>{pDriverName}
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                            <Col xs={6} md={3}>
                                <b></b>
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row>
                            <Col xs={6} md={6}>
                                <Form>
                                    <Form.Check className="user-select-none" type="checkbox" id="chkVehicleRequired" label="Do you want to make vehicle mandatory?" ref={chkVehicleRequiredRef}/>
                                </Form>
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                            <Col xs={6} md={3}>
                            
                            </Col>
                        </Row>
                        </Container>
                    </Modal.Body>
            </Modal>:""}
            </HotKeys>
            {(showTreatedResaonDialog) ? <TreatedTripDialogue GridRowData={props.GridRowData} showDialog={showTreatedResaonDialog} setActionsDialog={setshowTreatedResaonDialog} /> : "" }
            {invokeAssignComponent && <AssignAction GridRowData={props.GridRowData} selectedDriver={selectedDriver} 
            selectedVehicle={selectedVehicle} invokeAssignComponent={invokeAssignComponent} chkVehicleRequiredRef={chkVehicleRequiredRef.current.checked} 
            setInvokeAssignComponent={setInvokeAssignComponent} />}
            {invokeDispatchComponent ? (<DispatchAction GridRowData={props.GridRowData} selectedDriver={selectedDriver} DispatchVehicleData={DispatchVehicleData} DispatchDriverData={DispatchDriverData}
            selectedVehicle={selectedVehicle} invokeDispatchComponent={invokeDispatchComponent} setinvokeDispatchComponent={UnMountDispatchActionComponent} chkVehicleRequiredRef={chkVehicleRequiredRef.current.checked}  />) : ""}
            {invokeUnAssignComponent && <UnAssignAction GridRowData={props.GridRowData} selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} invokeUnAssignComponent={invokeUnAssignComponent} setInvokeUnAssignComponent={setInvokeUnAssignComponent} setUnAssignrocessing={setUnAssignrocessing} RefreshGridData={RefreshGridData} />}
            {invokeNoShowComponent && <NoShow GridRowData={props.GridRowData} selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} invokeNoShowComponent={invokeNoShowComponent} setInvokeNoShowComponent={setInvokeNoShowComponent} RefreshGridData={RefreshGridData} />}
            {invokeNoShowReqComponent && <NOSHOWREQ GridRowData={props.GridRowData} selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} invokeNoShowReqComponent={invokeNoShowReqComponent} setInvokeNoShowReqComponent={setInvokeNoShowReqComponent} RefreshGridData={RefreshGridData} />}
            {invokePauseUnPauseComponent && <PauseUnPause GridRowData={props.GridRowData} invokePauseUnPauseComponent={invokePauseUnPauseComponent} setPauseUnPauseComponent={setPauseUnPauseComponent} btnPauseTripText={btnPauseTripText} setBtnPauseTripText={setBtnPauseTripText} setPauseProcessing={setPauseProcessing} RefreshGridData={RefreshGridData} />}
            {invokeDueNowComponent && <DueNow GridRowData={props.GridRowData} invokeDueNowComponent={invokeDueNowComponent} setInvokeDueNowComponent={setInvokeDueNowComponent} setDueNowProcessing={setDueNowProcessing} RefreshGridData={RefreshGridData} />}
            {forceDispatchObj.invokeForceDispatch && <ForceDispatch GridRowData={props.GridRowData} invokeForceDispatch={forceDispatchObj.invokeForceDispatch} 
            setForceDispatchObj={setForceDispatchObj} isForceDispatchProcessing={forceDispatchObj.isForceDispatchProcessing} 
            selectedDriver={selectedDriver} selectedVehicle={selectedVehicle} chkVehicleRequiredRef={chkVehicleRequiredRef.current.checked} RefreshGridData={RefreshGridData} />}
            {ShowModalDialog.Show?(
                <Modal centered show={ShowModalDialog.Show} onHide={HideDialogueMsg} keyboard={true}  animation={true} backdrop="static" >
                    <Modal.Header className="dispatch_action_dialog_header_bgcolor" style={{height: "50px"}} closeButton>
                        <Modal.Title className="dispatch_action_dialog_title_color user-select-none">{ShowModalDialog.Title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none">
                        <b>{ShowModalDialog.Msg}</b>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={HideDialogueMsg}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>)
                : ""}   

            {shortcutMenu ? 
                <Modal show={shortcutMenu? 1:0} centered onHide={handleInvokeShortcutModalToggle} backdrop="static" keyboard={true} size="lg" animation={true}>
                    <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title className="activate_dialog_title_color user-select-none">
                        Shortcut Keys Info 
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Container>
                        <Row>
                        <Col className='w-100'>
                            <table className='w-100 text-center prevent-select'>
                            <tbody>
                                <tr>
                                <th className="border border-light activate_dialog_header_bgcolor text-light">Action</th>
                                <th className="border border-light activate_dialog_header_bgcolor text-light">Shortcut</th>
                                </tr>
                                {shortcutListHTML}
                            </tbody>
                            </table>
                        </Col>
                        </Row>
                    </Container>
                    </Modal.Body>
                </Modal>
            :""}
        </>
        
    );
}

export default TripActions;